import styled from 'styled-components';
import { Scrollbars } from 'react-custom-scrollbars';

import { useCustomTheme } from '../../styles';
import { ScrollableViewProps } from './scrollable-view';


const Root = styled(Scrollbars)<ScrollableViewProps>``;

const ThumbVertical = styled.div`
	width: 6px !important;
	right: -3px;
	z-index: 1000;

	${p => `
		background-color: ${useCustomTheme(p)[0].palette.accentPrimary};
	`}
`;

const ThumbHorizontal = styled.div`
	height: 6px !important;
	top: 3px;
	z-index: 1000;

	${p => `
		background-color: ${useCustomTheme(p)[0].palette.accentPrimary};
	`}
`;


export {
	Root,
	ThumbVertical,
	ThumbHorizontal,
}